export default (str, len) =>
  str && typeof str === 'string'
    ? str.length > len
      ? `${str.substr(0, len)}..`
      : str
    : '';
